import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { MODAL_TYPE } from './Modal'
import Glyph from 'component/utils/Glyph'
import { DEPARTMENTS } from 'constants/config'

export default class DatasheetManagementTable extends PureComponent {
  static propTypes = {
    current: PropTypes.number.isRequired,
    datasheetManagementList: PropTypes.array.isRequired,
    openModal: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    sections: PropTypes.object
  }

  getName = (item, level) => {
    let section

    const { sections } = this.props

    switch (level) {
      case 2:
        section = (sections[level] || []).find(
          (section) => section.sectionId === item.sectionId
        )
        break
      case 3:
        section = (sections[level] || []).find(
          (section) =>
            section.sectionId === item.sectionId &&
            section.subSectionId === item.subSectionId
        )
        break
      case 4:
        section = (sections[level] || []).find(
          (section) =>
            section.sectionId === item.sectionId &&
            section.subSectionId === item.subSectionId &&
            section.typeId === item.typeId
        )
        break
      case 5:
        section = (sections[level] || []).find(
          (section) =>
            section.sectionId === item.sectionId &&
            section.subSectionId === item.subSectionId &&
            section.typeId === item.typeId &&
            section.subTypeId === item.subTypeId
        )
        break
      default:
        break
    }

    if (section) {
      return `${section[DEPARTMENTS[level]]} - ${section.description}`
    }
    return null
  }

  renderRows = (dm) => {
    const { translate, openModal } = this.props
    const sectionIdNm = this.getName(dm, 2)
    const subSectionIdNm = this.getName(dm, 3)
    const typeIdNm = this.getName(dm, 4)
    const subTypeIdNm = this.getName(dm, 5)

    return (
      <tr key={dm.idDatasheetManagement} className='tr-height-fixed'>
        <td className='margin-y'>
          {
            <span className='margin-y-extra-small show'>
              {sectionIdNm ? (
                <span>
                  <strong>{`${translate('section')}: `}</strong>
                  {`${sectionIdNm}`}
                </span>
              ) : (
                '-'
              )}
            </span>
          }
          {
            <span className='margin-y-extra-small show'>
              {subSectionIdNm ? (
                <span>
                  <strong>{`${translate('subSection')}: `}</strong>
                  {`${subSectionIdNm}`}
                </span>
              ) : (
                '-'
              )}
            </span>
          }
        </td>
        <td className='margin-y'>
          {
            <span className='margin-y-extra-small show'>
              {typeIdNm ? (
                <span>
                  <strong>{`${translate('type')}: `}</strong>
                  {`${typeIdNm}`}
                </span>
              ) : (
                '-'
              )}
            </span>
          }
          {
            <span className='margin-y-extra-small show'>
              {subTypeIdNm ? (
                <span>
                  <strong>{`${translate('subType')}: `}</strong>
                  {`${subTypeIdNm}`}
                </span>
              ) : (
                '-'
              )}
            </span>
          }
        </td>
        <td className='margin-y'>
          {dm.datasheetFormat.map((format) => (
            <span
              key={format.idDatasheetFormat}
              className='margin-y-extra-small show'
            >
              {format.nmDatasheetFormat}
              {format.angleDatasheetFormat && (
                <span>
                  {` | `}
                  <strong>
                    {translate('datasheetManagement.angle').concat(
                      ` ${format.angleDatasheetFormat}`
                    )}
                  </strong>
                </span>
              )}
            </span>
          ))}
        </td>
        <td className='table-icon-center'>
          <Glyph
            type='pencil'
            color='primary'
            customClass='cursor-pointer'
            onClick={() => openModal(MODAL_TYPE.EDIT, dm)}
          />
        </td>
        <td className='table-icon-center'>
          <Glyph
            type='trash-can'
            color='danger'
            customClass='cursor-pointer'
            onClick={() => openModal(MODAL_TYPE.DELETE, dm)}
          />
        </td>
      </tr>
    )
  }

  render() {
    const { datasheetManagementList, translate } = this.props

    return (
      <div className='menu-mission new-style table-justification-standard'>
        <table className='new-table no-border-spacing'>
          <thead>
            <tr>
              <th>{translate('section.and.subsection')}</th>
              <th>{translate('type.and.subtype')}</th>
              <th>{translate('format.and.angle')}</th>
              <th className='text-center'>{translate('commonReport.edit')}</th>
              <th className='text-center'>
                {translate('commonReport.delete')}
              </th>
            </tr>
          </thead>
          <tbody>{datasheetManagementList.map(this.renderRows)}</tbody>
        </table>
      </div>
    )
  }
}
